import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';

import formatPrice from 'utils/formatPrice';
import pxToEm from 'styles/pxToEm';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  label: {
    display: 'block',
    position: 'relative',
    marginBottom: 0,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  typography: {
    display: 'block',
    padding: '4px 0',
    lineHeight: pxToEm(16, 14),
    minHeight: pxToEm(16, 14),
  },
});

const InventoryStockLineCreateEditTotalPriceFields = ({ variant, classes, ...fields }) => {
  let quantity;
  let price;
  switch (variant) {
    case 'Boxes':
      quantity = get(fields, 'Boxes Quantity').input.value;
      price = Number(get(fields, 'Price per Box').input.value.toString().replace(/[$,]/g, ''));
      break;
    case 'Kcal Units':
      // code block
      break;
    default:
      quantity = get(fields, 'Units Quantity').input.value;
      price = Number(get(fields, 'Price per Unit').input.value.toString().replace(/[$,]/g, ''));
  }

  let totalPrice = quantity && price ? quantity * price : null;
  if (totalPrice && Math.round(totalPrice) !== totalPrice) {
    totalPrice = totalPrice.toFixed(2);
  }
  if (!totalPrice) {
    return '';
  }
  return (
    <Grid item>
      <InputLabel
        className={classes.label}
        disableAnimation
        shrink={false}
      >
        Total Cost:
      </InputLabel>
      <Typography className={classes.typography}>
        {totalPrice && formatPrice(totalPrice)}
      </Typography>
    </Grid>
  );
};

InventoryStockLineCreateEditTotalPriceFields.propTypes = {
  variant: PropTypes.oneOf(['Units', 'Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineCreateEditTotalPriceFields.defaultProps = {
  variant: 'Units',
};

export default withStyles(styles)(InventoryStockLineCreateEditTotalPriceFields);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditTotalPriceFields.js